import script from "./foreignPage.vue?vue&type=script&setup=true&lang=js"
export * from "./foreignPage.vue?vue&type=script&setup=true&lang=js"

import "./foreignPage.vue?vue&type=style&index=0&id=77c41af9&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77c41af9"]])

export default __exports__